module.exports = __webpack_public_path__ + "img/CS_new_icons_dark.40dcaa55.png";